import React, { useState } from 'react';
import { Accordion, Button } from 'react-bootstrap';
const AccordionToggle = ({ doc }) => {
    const [activeParentDocId, setActiveParentDocId] = useState();
    const handleParentDocumentClick = () => {
        activeParentDocId !== undefined
            ? setActiveParentDocId(undefined)
            : setActiveParentDocId(doc.id);
    };
    const isActiveDoc = doc.id === activeParentDocId;
    return (React.createElement(Accordion.Toggle, { as: Button, variant: 'link', className: 'expand-toggle-button', eventKey: `${doc.id}-id`, onClick: handleParentDocumentClick },
        React.createElement("span", { className: 'document-item' },
            React.createElement("div", { className: `overflow-ellipsis ${isActiveDoc ? 'selected' : ''}`, onClick: e => {
                    e.stopPropagation();
                    const win = window.open(`/document/${doc.id}`, '_blank');
                    if (win)
                        win.focus();
                }, title: doc.name }, doc.name),
            React.createElement("div", { key: `${doc.id}-${isActiveDoc}` },
                React.createElement("span", { className: 'fa-stack' },
                    React.createElement("i", { className: 'fas fa-circle fa-stack-1x' }),
                    React.createElement("i", { className: !isActiveDoc
                            ? 'fal fa-angle-down fa-stack-1x'
                            : 'fal fa-angle-up fa-stack-1x' }))))));
};
export default AccordionToggle;
